// src/components/SupplierListModal.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";

const SupplierListModal = ({ showModal, closeModal, onSelectVehicle, branch }) => {
  const [supplier, setSupplier] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showModal) {
      fetchPendingList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, search]);

  const fetchPendingList = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stnOutward_reqPending", {
        params: { branchcode: branch, searchTerm: search },
      });
      setSupplier(response.data || []);
    } catch (error) {
      console.error("Error fetching STN pending:", error);
      setSupplier([]);
    }
    setLoading(false);
  };

  // Send back structured selection (number + toBranch + due date)
  const handleSelect = (row) => {
    const payload = {
      stnReqNo: row.stn_purnumber,
      toBranch: row.stn_branchcode,
      dueDate: row.stn_duedate,
    };
    onSelectVehicle(payload);
    closeModal();
  };

  return (
    <div className={`custom-modal-overlay ${showModal ? "visible" : ""}`}>
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h2>STN Requisition Pending Number</h2>
          <button className="custom-modal-close" onClick={closeModal}>✖</button>
        </div>

        <input
          type="text"
          className="custom-modal-search"
          placeholder="Search STN No..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="custom-modal-list">
          {loading ? (
            <p className="custom-loading-text">Loading...</p>
          ) : supplier.length > 0 ? (
            supplier.map((item, index) => (
              <div
                key={index}
                className="custom-modal-item"
                onClick={() => handleSelect(item)}
              >
                {item.stn_purnumber} - {item.stn_branchcode} (
                <span style={{ color: "Red" }}>Due Date :</span>{" "}
                {item.stn_duedate
                  ? new Date(item.stn_duedate).toLocaleDateString("en-GB")
                  : "-"}
                )
              </div>
            ))
          ) : (
            <p className="custom-no-data">No STN Requests found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplierListModal;
